const keyToChangeFront = [
  'thicknessAfter',
  'coveragePower',
  'minimumBag',
  'bagWeight',
  'bagByPalette',
  'kiloByPalette',
  'thicknessBefore',
];

const keyToChangeBack = [
  'thick_after_crush',
  'covering_power_kg_m2',
  'min_bag_per_100m2',
  'weight',
  'number_bag_per_pallet',
  'number_kg_per_pallet',
  'thick_before_crush',
];

const optionsWorkstype = [
  { key: "3", text: "Optimale", value: "3" },
  { key: "2", text: "Performante", value: "2" },
  { key: "1", text: "Basique", value: "1" }
];

const optionsProductsType = [
  { key: "11", text: "Pastille", value: "11" },
  { key: "10", text: "Appuie intermédiaire", value: "10" },
  { key: "9", text: "Isolant", value: "9" },
  { key: "8", text: "Mastic", value: "8" },
  { key: "7", text: "Membrane", value: "7" },
  { key: "5", text: "Suspentes", value: "5" },
  { key: "4", text: "Manchons", value: "4" },
  { key: "3", text: "Adhesif", value: "3" },
  { key: "2", text: "Sous Chevrons", value: "2" },
  { key: "1", text: "Entre Chevrons", value: "1" },
  { key: '12', text: "isolent entre solives", value: '12'},
  { key: '13', text: "Isolant 2 éme passe", value: '13'},
  { key: '14', text: "Isolant soufflé", value: '14'},
];

export {
  keyToChangeFront,
  keyToChangeBack,
  optionsWorkstype,
  optionsProductsType,
};


// WEBPACK FOOTER //
// ./src/components/Protected/Article/const.js